import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Container, Menu, MenuItem } from "@mui/material";
import { useRef, useState } from "react";
import Button from "../../../components/CustomButton";
import { AppColors } from "../../../util/AppColors";
import AppointmentsFacilityReport from "./Appointments/AppointmentsFacilityReport";
import AppointmentsTableReport from "./Appointments/AppointmentsTableReport";
import AppointmentsTabTableReport from "./Appointments/AppointmentsTabTableReport";
import BillingPurchaseReturnReport from "./Billing/BillingPurchaseReturnReport";
import BillingRevenueReport from "./Billing/BillingRevenueReport";
import BillingSalesReturnReport from "./Billing/BillingSalesReturnReport";
import AppointmentsReport from "./Pets/AppointmentsReport";
import PetDetailsReport from "./Pets/PetDetailsReport";
import ServiceLevel2Report from "./Service/ServiceLevel2Report";
import ServiceTableReport from "./Service/ServiceTableReport";
import StockBatchReport from "./Stock/StockBatchReport";
import StockDumpReport from "./Stock/StockDumpReport";
import StockReturnReport from "./Stock/StockReturnReport";
import VetsDelayReport from "./Vets/VetsDelayReport";
import VetsRevenueReport from "./Vets/VetsRevenueReport";
import VetsSlotsReport from "./Vets/VetsSlotsReport";
import VetsSpecialityReport from "./Vets/VetsSpecialityReport";
import VetsUpcomingReport from "./Vets/VetsUpcomingReport";

const tabArray = [
  {
    name: "Vets",
    tabs: ["Revenue", "Speciality", "Slots", "Delay", "Upcoming"],
  },
  { name: "Pets", tabs: ["Appointments", "Pets"] },
  { name: "Appointments", tabs: ["Appointments", "Table", "Facility"] },
  { name: "Billing", tabs: ["Revenue", "Sales Return", "Purchase Return"] },
  { name: "Inventory Stock", tabs: ["Dump", "Batch", "Return"] },
  { name: "Inventory Service", tabs: ["Table", "Level2"] },
];

const Reports = () => {
  // Selected sub-tab per group (e.g. { Vets: "Revenue", Pets: "Appointments" })
  const [selectedTabsByGroup, setSelectedTabsByGroup] = useState(() =>
    tabArray.reduce(
      (acc, { name, tabs }) => ({ ...acc, [name]: tabs?.[0] }),
      {},
    ),
  );
  const [activeTab, setActiveTab] = useState("Vets");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const closeTimeoutRef = useRef(null);

  const handleMenuEnter = (e, index) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setAnchorEl(e.currentTarget);
    setOpenMenuIndex(index);
  };

  const handleMenuLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setAnchorEl(null);
      setOpenMenuIndex(null);
    }, 150);
  };

  const handleMenuItemClick = (groupName, subTab) => {
    setActiveTab(groupName);
    setSelectedTabsByGroup((prev) => ({ ...prev, [groupName]: subTab }));
    setAnchorEl(null);
    setOpenMenuIndex(null);
  };

  const selectedTab = selectedTabsByGroup[activeTab];

  return (
    <Container maxWidth="xl">
      <div className="com-mar back-white p20 ">
        <div className="flex-row-ali-cen">
          {tabArray?.map((li, i) => {
            const groupSelectedTab =
              selectedTabsByGroup[li?.name] ?? li?.tabs?.[0];
            return (
              <div
                onMouseEnter={(e) => handleMenuEnter(e, i)}
                onMouseLeave={handleMenuLeave}
                key={`${li?.name}_${i}`}
                className="ml10"
              >
                <div className="txt-semi-bold fs14 ml10">{li?.name}</div>
                <Button
                  text={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      {groupSelectedTab}
                      <ArrowDropDownIcon
                        style={{ color: "gray", fontSize: 20 }}
                      />
                    </span>
                  }
                  tabSelectdBtn={activeTab === li?.name}
                  textBtn={activeTab !== li?.name}
                  color={AppColors.grayBtn2}
                />
                <Menu
                  anchorEl={anchorEl}
                  open={openMenuIndex === i && Boolean(anchorEl)}
                  onClose={() => {
                    setAnchorEl(null);
                    setOpenMenuIndex(null);
                  }}
                  MenuListProps={{
                    onMouseEnter: () => {
                      if (closeTimeoutRef.current) {
                        clearTimeout(closeTimeoutRef.current);
                        closeTimeoutRef.current = null;
                      }
                    },
                    onMouseLeave: handleMenuLeave,
                  }}
                >
                  {li?.tabs?.map((tb, ind) => (
                    <MenuItem
                      key={`${tb}_${ind}`}
                      onClick={() => handleMenuItemClick(li?.name, tb)}
                    >
                      {tb}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            );
          })}

          {/* <div>
            <CustomButton
              text="Overview"
              smallBtn
              tabOutlined
              yellowBtn={selectedTab === "Overview"}
              onClick={() => handleSelectedTab("Overview")}
            />
          </div>
          <div className="tab-split-tab-ver-bar mh15" /> */}
          {/* <div>
            <CustomButton
              text="Download Reports"
              smallBtn
              tabOutlined
              yellowBtn={selectedTab === "DownloadReports"}
              onClick={() => handleSelectedTab("DownloadReports")}
            />
          </div> */}
        </div>
        <div className="mt10">
          {activeTab === "Vets" ? (
            selectedTab === "Revenue" ? (
              <VetsRevenueReport />
            ) : selectedTab === "Speciality" ? (
              <VetsSpecialityReport />
            ) : selectedTab === "Slots" ? (
              <VetsSlotsReport />
            ) : selectedTab === "Delay" ? (
              <VetsDelayReport />
            ) : selectedTab === "Upcoming" ? (
              <VetsUpcomingReport />
            ) : null
          ) : null}
          {activeTab === "Pets" ? (
            selectedTab === "Appointments" ? (
              <AppointmentsReport />
            ) : selectedTab === "Pets" ? (
              <PetDetailsReport />
            ) : null
          ) : null}
          {activeTab === "Appointments" ? (
            selectedTab === "Appointments" ? (
              <AppointmentsTableReport />
            ) : selectedTab === "Table" ? (
              <AppointmentsTabTableReport />
            ) : selectedTab === "Facility" ? (
              <AppointmentsFacilityReport />
            ) : null
          ) : null}
          {activeTab === "Billing" ? (
            selectedTab === "Revenue" ? (
              <BillingRevenueReport />
            ) : selectedTab === "Sales Return" ? (
              <BillingSalesReturnReport />
            ) : selectedTab === "Purchase Return" ? (
              <BillingPurchaseReturnReport />
            ) : null
          ) : null}
          {activeTab === "Inventory Stock" ? (
            selectedTab === "Dump" ? (
              <StockDumpReport />
            ) : selectedTab === "Batch" ? (
              <StockBatchReport />
            ) : selectedTab === "Return" ? (
              <StockReturnReport />
            ) : null
          ) : null}
          {activeTab === "Inventory Service" ? (
            selectedTab === "Table" ? (
              <ServiceTableReport />
            ) : selectedTab === "Level2" ? (
              <ServiceLevel2Report />
            ) : null
          ) : null}
        </div>
        {/* {selectedTab === "Overview" ? <ReportOverview /> : <DownloadReports />} */}
      </div>
    </Container>
  );
};

export default Reports;
